import { ReactNode, useState } from "react";

import { useMenuContext } from "@/lib/context/MenuProvider/hooks/useMenuContext";
import { ButtonType } from "@/lib/types/Button";

import styles from "./PageHeader.module.scss";

import { FeedbackModal } from "../FeedbackModal/FeedbackModal";
import { Icon } from "../ui/Icon/Icon";
import { ProfileButton } from "../Menu/components/ProfileButton/ProfileButton";
import { LanguageSwitcher } from "../ui/LanguageSwitcher/LanguageSwitcher";
import Button from "../ui/Button";
import { useLogoutModal } from "@/lib/hooks/useLogoutModal";
import { useTranslation } from "react-i18next";
import { ConfirmationModal } from "../ConfirmationModal/ConfirmationModal";

type Props = {
  iconName?: string;
  buttons?: ButtonType[];
  snippetEmoji?: string;
  snippetColor?: string;
  title?: ReactNode;
  onBack?: () => void;
};

export const PageHeader = ({
  buttons = [],
  title,
  onBack,
}: Props): JSX.Element => {
  const { isOpened } = useMenuContext();
  const [isFeedbackModalOpen, setFeedbackModalOpen] = useState(false);

  const isHomePage = location.pathname === "/";
  const {
    handleLogout,
    isLoggingOut,
    isLogoutModalOpened,
    setIsLogoutModalOpened,
  } = useLogoutModal();

  const { t } = useTranslation(["translation", "logout"]);

  return (
    <>
      <ConfirmationModal
        isOpen={isLogoutModalOpened}
        setOpen={setIsLogoutModalOpened}
        onConfirm={() => void handleLogout()}
        isLoading={isLoggingOut}
        title={t("areYouSure", { ns: "logout" })}
      />
      <FeedbackModal
        isOpen={isFeedbackModalOpen}
        setOpen={setFeedbackModalOpen}
      />
      <div
        style={{ color: isHomePage ? "#fff" : "inherit" }}
        className={styles.page_header_wrapper}
      >
        <div
          className={`${styles.left} ${!isOpened ? styles.menu_closed : ""}`}
        >
          <div className={styles.title_wrapper}>
            {onBack && (
              <button className={styles.back_button} onClick={onBack}>
                <Icon name="arrowBack" size="normal" color="black" />
              </button>
            )}
            {title && <div className={styles.title}>{title}</div>}
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.buttons_wrapper}>
            {buttons.map((button, index) => (
              <Button key={index} {...button} />
            ))}
          </div>
          <ProfileButton />
          <LanguageSwitcher />
          <Button
            iconName="logout"
            variant="text"
            onClick={() => setIsLogoutModalOpened(true)}
          >
            {t("logoutButton")}
          </Button>
        </div>
      </div>
    </>
  );
};

export default PageHeader;
